import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { LabTrendsChartComponent } from './lab-trends-chart.component';
import { StandardTestResultsMainComponent } from './standard-test-results-main.component';
import {StandardTestResultsComponent} from './standard-test-results.component';
import {CovanceAgGridModule} from '../../covance-ag-grid/covance-ag-grid.module';
import {LabBoxplotChartComponent} from './lab-boxplot-chart.component';
import {TestVisitAgRendererComponent} from './test-visit-ag-renderer.component';
import {TestTitleAgRendererComponent} from './test-title-ag-renderer.component';
import {TestSubjectAgRendererComponent} from './test-subject-ag-renderer.component';
import {CovanceFilterModule} from '../../covance-filter/covance-filter.module';
import { GroupingModule } from '../../grouping-selector/grouping.module';
import { LegendModule } from '../../legend/legend.module';
import { CorporateModule } from '../../corporate/corporate.module';
import { StandardTestResultsAgGroupRendererComponent } from './standard-test-results-ag-group-renderer.component';
import { StandardTestResultsSort } from './standard-test-results-sort';
import { ChartsModule } from '../../charts/charts.module';
import { OnScreenResultsFilterDefenitions } from './on-screen-results-filter-defenitions';
import { LargeDataWarningComponent } from './large-data-warning.component';
import { DataRevisionStorage } from './data-revision-storage';
import { DataRevisionComponent } from './model-dialog/data-revision/data-revision.component';
import { ModalDialogService } from './model-dialog/ModalDialogService';

@NgModule({
    imports: [
        SharedModule,
        CovanceAgGridModule,
        CovanceFilterModule,
        GroupingModule,
        LegendModule,
        CorporateModule,
        ChartsModule
    ],
    declarations: [
        StandardTestResultsMainComponent,
        LabTrendsChartComponent,
        StandardTestResultsComponent,
        LabBoxplotChartComponent,
        TestVisitAgRendererComponent,
        TestTitleAgRendererComponent,
        TestSubjectAgRendererComponent,
        StandardTestResultsAgGroupRendererComponent,
        LargeDataWarningComponent,
        DataRevisionComponent
    ],
    entryComponents: [
        TestVisitAgRendererComponent,
        TestTitleAgRendererComponent,
        TestSubjectAgRendererComponent,
        StandardTestResultsAgGroupRendererComponent,
        DataRevisionComponent
    ],
    exports: [
        LargeDataWarningComponent,
        LabTrendsChartComponent,
        StandardTestResultsComponent,
        LabBoxplotChartComponent,
        DataRevisionComponent
    ],
    providers: [StandardTestResultsSort, OnScreenResultsFilterDefenitions, DataRevisionStorage, ModalDialogService]
})
export class StandardTestResultsMainModule { }